export const checkIsNextDay = (startTime: Date, endTime: Date) => {
  if (startTime.getHours() > endTime.getHours()) {
    return true;
  } else
    return (
      startTime.getHours() === endTime.getHours() &&
      startTime.getMinutes() >= endTime.getMinutes()
    );
};
